import Phaser from "phaser";
import { Palette } from "./ui/palette";
import { BootScene } from "./scenes/BootScene";
import { PreloadScene } from "./scenes/PreloadScene";
import { TitleScene } from "./scenes/TitleScene";
import { MarketSelectScene } from "./scenes/MarketSelectScene";
import { LevelSelectScene } from "./scenes/LevelSelectScene";
import { Level1DanScene } from "./scenes/Level1DanScene";
import { Level2LucasScene } from "./scenes/Level2LucasScene";
import { Level3AndrewScene } from "./scenes/Level3AndrewScene";
import { LevelResultScene } from "./scenes/LevelResultScene";
import { FinaleScene } from "./scenes/FinaleScene";
import { RelayScene } from "./scenes/RelayScene";
import { KirbyCallScene } from "./scenes/KirbyCallScene";
import { EndingScene } from "./scenes/EndingScene";
import { CreditsScene } from "./scenes/CreditsScene";
import { DialogueScene } from "./scenes/DialogueScene";
import { SubmitScoreScene } from "./scenes/SubmitScoreScene";
import { LeaderboardScene } from "./scenes/LeaderboardScene";
import { GameOverScene } from "./scenes/GameOverScene";
import { RegionConqueredScene } from "./scenes/RegionConqueredScene";
import { GameState } from "./state/GameState";
import { runWithPasswordGate } from "./ui/passwordGate";

export const GAME_WIDTH = 960;
export const GAME_HEIGHT = 540;

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "app",
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: Palette.bg,
  pixelArt: true,
  roundPixels: true,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: "arcade",
    arcade: {
      gravity: { x: 0, y: 900 },
      debug: false,
    },
  },
  scene: [
    BootScene,
    PreloadScene,
    TitleScene,
    MarketSelectScene,
    LevelSelectScene,
    Level1DanScene,
    Level2LucasScene,
    Level3AndrewScene,
    LevelResultScene,
    FinaleScene,
    RelayScene,
    KirbyCallScene,
    EndingScene,
    CreditsScene,
    SubmitScoreScene,
    LeaderboardScene,
    DialogueScene,
    GameOverScene,
    RegionConqueredScene,
  ],
};

// Gate the game behind a password when one is configured (see passwordGate.ts).
// No-op when the `password` env var is unset - the game starts immediately.
runWithPasswordGate(() => {
  const game = new Phaser.Game(config);

  // Expose for debugging + headless smoke tests (harmless in prod).
  (window as unknown as { game: Phaser.Game; GameState: typeof GameState }).game = game;
  (window as unknown as { game: Phaser.Game; GameState: typeof GameState }).GameState = GameState;
});
